import { z } from 'zod'

export enum MedSummarySourceProvider {
  LEGACY = 'legacy',
  USER_FILES = 'user_files',
}

export const MedSummaryLegacySourceRefSchema = z.object({
  provider: z.literal(MedSummarySourceProvider.LEGACY),
  source_id: z.string(),
  file_path: z.string(),
  display_name: z.string(),
})

export const MedSummaryUserFilesSourceRefSchema = z.object({
  provider: z.literal(MedSummarySourceProvider.USER_FILES),
  source_id: z.string(),
  display_name: z.string(),
})

export const MedSummarySourceRefSchema = z.discriminatedUnion('provider', [MedSummaryLegacySourceRefSchema, MedSummaryUserFilesSourceRefSchema])

export type MedSummarySourceRef = z.infer<typeof MedSummarySourceRefSchema>
